// NPM Imports
import React from "react";

// Component Imports
import Notes from "./Notes";
import NotesUpgrade from "./NotesUpgrade";
import { FeatureGating } from "../../commonComponents";

// Internal Imports
import { FEATURES } from "../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function (props) {
  return (
    <FeatureGating
      name={FEATURES_NAME.DOCUMENT_NOTES}
      altComponent={
        <NotesUpgrade {...props} featureName={FEATURES_NAME.DOCUMENT_NOTES} />
      }>
      <Notes {...props} />
    </FeatureGating>
  );
}
